export type AmplitudeTrackingState = boolean | 'pending'

let trackingState: AmplitudeTrackingState | undefined

export const getAmplitudeTrackingState = () => trackingState

export const setAmplitudeTrackingState = (state: AmplitudeTrackingState) => {
  trackingState = state
}

export const isAmplitudeTrackingAllowed = () =>
  trackingState === undefined || trackingState === true
